import React, { useState, useEffect } from 'react';
import { AJAX_URL } from '../../../config/index.js';
import Slider from 'react-slick';

// ux
import ListItem from './ListItem.js';

const FuseSlider = () => {
  const [randomFuses, setRandomFuses] = useState([]);

  // slider settings
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 9000,
    autoplaySpeed: 0,
    cssEase: 'linear',
    pauseOnHover: true,
    centerMode: true,
    variableWidth: true,
    centerPadding: '15px',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  // ajax request to get 10 random fuses
  const fetchRandomFuses = async () => {
    try {
      const response = await fetch(`${AJAX_URL}fl_fetch_random_fuses`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const jsonResponse = await response.json();
      if (jsonResponse.success && Array.isArray(jsonResponse.data)) {
        setRandomFuses(jsonResponse.data);
      } else {
        throw new Error('Data is not an array or success is false');
      }
    } catch (error) {
      console.error('Failed to fetch fuses:', error.message);
      setRandomFuses([]);
    }
  };

  useEffect(() => {
    fetchRandomFuses();
  }, []);

  return (
    <div className="fuse-slider">
      <div className="fuse-examples">
        <Slider {...settings}>
          {randomFuses.map((fuse) => (
            <ListItem key={fuse.ID} fuse={fuse} />
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default FuseSlider;
